import React from 'react';
import { PageNotFound } from '../../common/PageNotFound';
import { WaitListPage } from '../views/WaitlistPage';
import { WaitListStatusPage } from '../views/WaitlistStatusPage';

type WaitListControllerProps = {
  page?: 'main' | 'status';
};

export const WaitListController: React.FC<WaitListControllerProps> = ({ page = 'main' }) => {
  switch (page) {
    case 'main':
      return <WaitListPage />;
    case 'status':
      return <WaitListStatusPage />;
    default:
      return <PageNotFound />;
  }
};
